var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BLACK_700, BLACK_900, LILAC_400, TRANSPARENT, Typography, getTestId, isValidObject } from '@airtel/air-design-system';
import { useState } from 'react';
import { Image, View } from 'react-native';
import { getUpsellSubTitleStyles } from './UpsellSubTitleStyles';
export var UpsellSubTitle = props => {
  var subTitle = props.subTitle,
    benefitIconName = props.benefitIconName,
    subTitleDescription = props.subTitleDescription,
    _props$subTitleAccess = props.subTitleAccessibilityProps,
    subTitleAccessibilityProps = _props$subTitleAccess === void 0 ? {} : _props$subTitleAccess,
    isMobileScreen = props.isMobileScreen,
    style = props.style,
    testID = props.testID,
    restProps = __rest(props, ["subTitle", "benefitIconName", "subTitleDescription", "subTitleAccessibilityProps", "isMobileScreen", "style", "testID"]);
  var _useState = useState(TRANSPARENT),
    placeholderBgColor = _useState[0],
    setPlaceholderBgColor = _useState[1];
  var upsellSubTitleStyles = getUpsellSubTitleStyles(isMobileScreen);
  return _jsxs(View, Object.assign({}, getTestId(testID, 'UpsellSubtitle_Container'), {
    style: [upsellSubTitleStyles.container, style]
  }, restProps, {
    children: [(benefitIconName === null || benefitIconName === void 0 ? void 0 : benefitIconName.length) > 0 && _jsx(View, Object.assign({
      style: [upsellSubTitleStyles.iconSize, upsellSubTitleStyles.benefitImage, {
        backgroundColor: placeholderBgColor
      }]
    }, {
      children: _jsx(Image, Object.assign({}, getTestId(testID, 'benefitIcon'), {
        source: {
          uri: benefitIconName,
          width: upsellSubTitleStyles.iconSize.width,
          height: upsellSubTitleStyles.iconSize.height
        },
        style: [upsellSubTitleStyles.benefitImage],
        onError: () => setPlaceholderBgColor(LILAC_400)
      }))
    })), _jsxs(View, Object.assign({
      style: upsellSubTitleStyles.subTitleText
    }, subTitleAccessibilityProps, {
      children: [!!subTitle && _jsx(Typography, Object.assign({}, getTestId(testID, 'subTitle'), {
        text: subTitle,
        type: isMobileScreen ? subTitleDescription ? 'body-single-line-xs-bold' : 'body-para-xs-bold' : subTitleDescription ? 'body-single-line-sm-bold' : 'body-para-sm-bold',
        numberOfLines: subTitleDescription ? 1 : 2,
        color: BLACK_900,
        accessible: !isValidObject(subTitleAccessibilityProps)
      })), !!subTitleDescription && _jsx(Typography, Object.assign({
        text: subTitleDescription,
        type: isMobileScreen ? 'body-single-line-xs' : 'body-single-line-sm',
        color: BLACK_700
      }, getTestId(testID, 'subTitleDescription'), {
        accessible: !isValidObject(subTitleAccessibilityProps)
      }))]
    }))]
  }));
};